import React from "react";
import { useTranslation } from "react-i18next";

interface NavbarProps {
  navlist: {
    key: any;
    title: any;
  }[];
  justified?: boolean;
  active: any;
  className?: string;
  onSelect: (tab: any) => void;
}

/**
 * Yeni nesil sekme çubuğu (underline). Eski reactstrap Nav + detailPageNavMenu
 * çakışması atıldı; kendi temiz markup'ı.
 */
const CustomNavbar = ({ navlist, active, onSelect }: NavbarProps) => {
  const { t } = useTranslation();
  return (
    <div className="m-tabs">
      {navlist.map((item) => (
        <button
          key={item.key}
          type="button"
          className={"m-tabs__tab" + (active === item.key ? " is-active" : "")}
          onClick={() => onSelect(item.key)}
        >
          {t(item.title)}
        </button>
      ))}
    </div>
  );
};
export default CustomNavbar;
